import { useQuery } from '@tanstack/react-query';

import { statsApi } from '@/services/stats';

export const statsKeys = {
  postsDaily: (days: number, cats?: number[]) =>
    ['stats', 'posts', 'daily', days, cats] as const,
  openai: (days: number) => ['stats', 'openai', days] as const,
};

export function usePostsDailyStats(days = 14, categories?: number[]) {
  return useQuery({
    queryKey: statsKeys.postsDaily(days, categories),
    queryFn: () => statsApi.postsDaily(days, categories),
    staleTime: 5 * 60_000,
  });
}

export function useOpenAiCostStats(days = 30) {
  return useQuery({
    queryKey: statsKeys.openai(days),
    queryFn: () => statsApi.openaiCost(days),
    staleTime: 60_000,
  });
}
